'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import V from "../defs/Trophy.js";
var f = Object.defineProperty, i = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var m = (r, o, e) => o in r ? f(r, o, { enumerable: true, configurable: true, writable: true, value: e }) : r[o] = e, a = (r, o) => {
  for (var e in o || (o = {}))
    c.call(o, e) && m(r, e, o[e]);
  if (t)
    for (var e of t(o))
      h.call(o, e) && m(r, e, o[e]);
  return r;
}, p = (r, o) => i(r, s(o));
const w = forwardRef((r, o) => /* @__PURE__ */ a__default.createElement(b, p(a({ ref: o }, r), { weights: V })));
w.displayName = "Trophy";
export {
  w as Trophy
};
